import { render, staticRenderFns } from "./NavigatorItemRoutes.vue?vue&type=template&id=15f89ed4&"
import script from "./NavigatorItemRoutes.vue?vue&type=script&lang=js&"
export * from "./NavigatorItemRoutes.vue?vue&type=script&lang=js&"
import style0 from "./NavigatorItemRoutes.vue?vue&type=style&index=0&id=15f89ed4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports